import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";

function PayPalPayment() {
  return (
    <PayPalScriptProvider options={{ clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID!}}>
      <Checkout />
    </PayPalScriptProvider>
  );
}

function Checkout() {
  return (
    <PayPalButtons
      createOrder={(data, actions) => {
        return actions.order!.create({
          intent: "CAPTURE",
          purchase_units: [
            {
              amount: {
                currency_code: "USD",
                value: "10.00",
              },
            },
          ],
        });
      }}
      onApprove={(data, actions) => {
        return actions.order!.capture().then((details:any) => {
          alert(`Transaction completed by ${details.payer.name?.given_name}`);
        });
      }}
    />
  );
}

export default PayPalPayment;
